import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/page.tsx");
